import { useMutation, useQuery, useQueryClient } from 'react-query'
import { QUERYKEY_ACTIVATIONOBJECT } from '../activationObject/hooks'
import { ProblemDetails } from '../errors'
import { authorize, getMe } from './services'
import { ApiTokenPayload, ApiTokenReponse, ApiUser } from './types'

export const QUERYKEY_USERME = 'me'
export function useUserQuery(token?: string) {
    return useQuery<ApiUser, ProblemDetails>(QUERYKEY_USERME, () => getMe(token), {
        enabled: token !== undefined,
        retry: false,
    })
}

export function useUserAuthentification() {
    const client = useQueryClient()
    return useMutation<ApiTokenReponse, ProblemDetails, ApiTokenPayload>((payload) => authorize(payload), {
        onSuccess: () => {
            client.invalidateQueries([QUERYKEY_USERME, QUERYKEY_ACTIVATIONOBJECT])
        },
    })
}
